module.exports = __webpack_public_path__ + "static/img/warnpic.62836c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/image/warnpic.png
// module id = f+xS
// module chunks = 1